import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// styles
import styles from './SearchBar-style.scss';

const SearchBarTerm = ({ href, term, handleRowClick, cursorHighlightId, id }) => {
    const searchBarTermClasses = classnames(styles.item, {
        [styles.active]: id === cursorHighlightId,
    });

    return (
        <div className={searchBarTermClasses}>
            <span
                data-tn="search-bar-term"
                className={styles.link}
                onClick={() => handleRowClick(term, href)}
            >
                {term}
            </span>
        </div>
    );
};

SearchBarTerm.propTypes = {
    term: PropTypes.string,
    href: PropTypes.string,
    handleRowClick: PropTypes.func,
    cursorHighlightId: PropTypes.string,
    id: PropTypes.string,
};

export default SearchBarTerm;
